import React from 'react'
import { useMedia, useMemo } from 'sb-hooks'
import { Modal, ModalVisibilityProps } from 'sb-modal'

import { Box } from 'components/_new/layout'
import Text from 'components/_new/typography/Text/Text'
import { ProgressBar, ContentLoader } from 'components/_new/ui'
import Link from 'components/_new/typography/Link/Link'

import TagList from './components/TagList/TagList'

import messages from './messages'
import s from './ReviewTagsModalView.scss'


type ReviewTagsModalViewProps = Pick<ModalVisibilityProps, 'onClose'> & {
  step: number
  stepCount: number
  type: string
  tags: Review.Tag[]
  isFetching: boolean
  onVote: (tagId: number) => void
  onSkip: () => void
}

const ReviewTagsModalView: React.FunctionComponent<ReviewTagsModalViewProps> = (props) => {
  const { step, stepCount, type, tags, isFetching, onVote, onSkip, onClose } = props
  const { isMobile } = useMedia()

  const title = messages.titleByType[type] || messages.titleByType.default
  const showTitleAndText = step === 1 || !isMobile

  const buttonProps = useMemo(() => ({
    type: 'button',
    rightIcon: 'rightArrowSmall',
    title: messages.skip,
    onClick: onSkip,
  }), [ onSkip ])

  return (
    <Modal
      className={s.modal}
      title={showTitleAndText ? messages.title : null}
      text={showTitleAndText ? messages.text : null}
      ordinaryButton={isMobile && !isFetching ? buttonProps : null}
      onClose={onClose}
    >
      {
        stepCount > 0 && (
          <ProgressBar
            className={s.progressBar}
            progress={100 * step / stepCount}
          />
        )
      }
      {
        isFetching ? (
          <ContentLoader className={s.loader} />
        ) : (
          <Box mt={32}>
            <Text
              message={{ ...messages.step, values: { step, stepCount } }}
              size="14-16"
              color="brand"
            />
            <Box mt={8}>
              <Text size="28-40" semibold message={title} />
            </Box>
            <Box mt={24} mb={16}>
              <TagList items={tags} onVote={onVote} />
            </Box>
            {
              !isMobile && (
                <Box mt={48} mb={24} ph={8}>
                  <Link
                    message={buttonProps.title}
                    semibold
                    withArrow
                    withUnderline={false}
                    onClick={onSkip}
                  />
                </Box>
              )
            }
          </Box>
        )
      }
    </Modal>
  )
}


export default ReviewTagsModalView
